import { render, staticRenderFns } from "./ConversationInfo.vue?vue&type=template&id=890829be&scoped=true"
import script from "./ConversationInfo.vue?vue&type=script&lang=js"
export * from "./ConversationInfo.vue?vue&type=script&lang=js"
import style0 from "./ConversationInfo.vue?vue&type=style&index=0&id=890829be&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890829be",
  null
  
)

export default component.exports